import { useQuery, UseQueryOptions } from "@tanstack/react-query";

import { shippingMethodsClient } from "@core/clients";
import { SHIPPING_METHODS_QUERY_CACHE_EXPIRE_TIME_MS } from "../../config/constansts";
import { PickupPoint } from "@core/types";

type Props = { 
  zoneId: string,
  options: UseQueryOptions<PickupPoint[]> 
}

const useGetPickupPoints = ({zoneId, options}: Props) => {
  return useQuery<PickupPoint[], any>(
    ["pickup-points"],
    async () => {
      return await shippingMethodsClient.getPickupPoints(zoneId);
    },
    {
      cacheTime: SHIPPING_METHODS_QUERY_CACHE_EXPIRE_TIME_MS,
      staleTime: SHIPPING_METHODS_QUERY_CACHE_EXPIRE_TIME_MS,
      ...options,
    }
  );
};

export default useGetPickupPoints;
